import {
    USER_ACCOUNT,
    USER_MY_DATA,
    USER_MY_OFFERS,
    USER_MY_BUY_OFFERS,
    USER_MY_PRODUCTS,
    USER_MY_ARTICLES,
    USER_DEALER,
    USER_WALLET,
    USER_WATCHED,
    MESSAGES_PAGE,
    LOGOUT_PAGE,
    ADD_PARTNER_PRODUCT,
    ADD_PARTNER_ARTICLE,
} from '@constants/routes'

const HOST = process.env.NEXT_PUBLIC_HOST

const isPartner = (user) => Boolean(user?.is_partner)
const isNotPartner = (user) => !isPartner(user)
const isFirm = (user) => Boolean(user?.dealer?.firm_nip) && !isPartner(user)

// Jedno źródło sekcji konta: menu „Moje konto” w nagłówku, grupa „Konto” w szufladzie, menu boczne i lista /profil.
// group: sekcje konta, potem „more” (obserwowane, wiadomości), na końcu wylogowanie. summary — liczby z /api/user/account_summary.
const links = [
    { key: 'ogloszenia', t: 'Moje ogłoszenia', to: USER_MY_OFFERS, icon: 'doc', condition: isNotPartner },
    { key: 'kupno', t: 'Moje oferty kupna', to: USER_MY_BUY_OFFERS, icon: 'cart', condition: (user, summary) => isNotPartner(user) && summary?.buy > 0 },

    { key: 'produkty', t: 'Moje produkty', to: USER_MY_PRODUCTS, icon: 'doc', condition: isPartner },
    { key: 'artykuly', t: 'Moje artykuły', to: USER_MY_ARTICLES, icon: 'doc', condition: isPartner },
    { key: 'dodaj-produkt', t: 'Dodaj produkt', to: ADD_PARTNER_PRODUCT, icon: 'plus', condition: isPartner },
    { key: 'dodaj-artykul', t: 'Dodaj artykuł', to: ADD_PARTNER_ARTICLE, icon: 'plus', condition: isPartner },

    { key: 'portfel', t: 'Mój portfel', to: USER_WALLET, icon: 'wallet' },
    { key: 'wizytowka', t: 'Wizytówka firmy', to: USER_DEALER, icon: 'card', condition: isFirm },
    { key: 'dane', t: 'Moje dane', to: USER_MY_DATA, icon: 'user' },

    { key: 'obserwowane', t: 'Obserwowane', to: USER_WATCHED, icon: 'heart', group: 'more' },
    { key: 'wiadomosci', t: 'Wiadomości', to: MESSAGES_PAGE, icon: 'chat', group: 'more' },

    { key: 'wyloguj', t: 'Wyloguj się', to: LOGOUT_PAGE, icon: 'out', group: 'out' },
]

function accountLinks (user, summary) {
    return links
        .filter(link => !link.condition || link.condition(user, summary))
        .map(({ condition, ...link }) => ({ ...link, href: link.to && HOST + link.to }))
}

const accountHome = { key: 'konto', t: 'Konto — wszystkie sekcje', href: HOST + USER_ACCOUNT }

export {
    accountHome,
    accountLinks,
    isFirm,
}
